var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "创建号码清洗任务 ？",
        visible: _vm.createCleaningTaskDialog,
        width: "516px",
        "before-close": _vm.handleClose,
        "custom-class": "dialog-cleaning-task",
      },
      on: {
        "update:visible": function ($event) {
          _vm.createCleaningTaskDialog = $event
        },
      },
    },
    [
      !_vm.taskType
        ? _c("p", { staticClass: "tip" }, [
            _c("i", { staticClass: "el-icon-warning" }),
            _c("span", { staticStyle: { color: "#262626" } }, [
              _vm._v("温馨提示："),
            ]),
            _vm._v("7天内已清洗的手机号不再重复清洗"),
          ])
        : _vm._e(),
      _c(
        "el-form",
        {
          ref: "cleaingTaskform",
          attrs: {
            rules: _vm.rules,
            model: _vm.cleaingTaskform,
            "label-width": "64px",
          },
        },
        [
          _c(
            "el-form-item",
            {
              staticClass: "task-name",
              attrs: { label: "任务名称", prop: "name" },
            },
            [
              _c("el-input", {
                attrs: { maxlength: "20", "show-word-limit": "" },
                model: {
                  value: _vm.cleaingTaskform.name,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.cleaingTaskform,
                      "name",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "cleaingTaskform.name",
                },
              }),
            ],
            1
          ),
          !_vm.taskType
            ? _c(
                "el-form-item",
                { staticClass: "choice-range", attrs: { label: "选择范围" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      on: { change: _vm.choiceRange },
                      model: {
                        value: _vm.cleaingTaskform.type,
                        callback: function ($$v) {
                          _vm.$set(_vm.cleaingTaskform, "type", $$v)
                        },
                        expression: "cleaingTaskform.type",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _vm._v("仅看关键人手机号"),
                      ]),
                      _c("el-radio", { attrs: { label: 3 } }, [
                        _vm._v("全部手机号"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          !_vm.taskType
            ? _c(
                "el-form-item",
                { staticClass: "choice-before", attrs: { label: "" } },
                [
                  _vm._v(" 清洗解锁列表前"),
                  _c("el-input", {
                    attrs: { type: "text" },
                    on: { input: _vm.inputCompanyNum },
                    model: {
                      value: _vm.cleaingTaskform.before,
                      callback: function ($$v) {
                        _vm.$set(_vm.cleaingTaskform, "before", $$v)
                      },
                      expression: "cleaingTaskform.before",
                    },
                  }),
                  _vm._v("条待检测的"),
                  _c(
                    "span",
                    {
                      staticClass: "colorC",
                      staticStyle: { "margin-left": "14px" },
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.cleaingTaskform.type == 1
                            ? "关键人手机号"
                            : _vm.cleaingTaskform.type == 2
                            ? "首位手机号"
                            : "手机号"
                        )
                      ),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
          _c("div", { class: ["txt", !_vm.taskType ? "plTxt" : ""] }, [
            _vm.taskType
              ? _c("p", [
                  _vm._v("总计清洗手机号:"),
                  _c("span", { staticClass: "colorC" }, [
                    _vm._v(_vm._s(_vm.cleaningMobileAndneedConsumeNum) + "条"),
                  ]),
                  _vm._v("，需要消耗"),
                  _c("span", { staticClass: "colorC" }, [
                    _vm._v(_vm._s(_vm.cleaningMobileAndneedConsumeNum) + "条"),
                  ]),
                  _vm._v("权益。"),
                ])
              : _c("p", [
                  _vm._v("需要消耗"),
                  _c("span", { staticClass: "colorC" }, [
                    _vm._v(_vm._s(_vm.cleaningMobileAndneedConsumeNum) + "条"),
                  ]),
                  _vm._v("权益。"),
                ]),
            _c("p", [
              _vm._v("当前剩余检测权益："),
              _c("span", { staticClass: "colorC" }, [
                _vm._v(_vm._s(_vm.cleaningNumberSusplus) + "条"),
              ]),
              _vm._v("。"),
            ]),
          ]),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "dialog-cancel", size: "small", w88: "" },
              on: {
                click: function ($event) {
                  _vm.createCleaningTaskDialog = false
                },
              },
            },
            [_vm._v("取消")]
          ),
          _c(
            "el-button",
            {
              attrs: {
                type: "primary",
                size: "small",
                w88: "",
                loading: _vm.loadingBtn,
              },
              on: {
                click: function ($event) {
                  return _vm.creatTask("cleaingTaskform")
                },
              },
            },
            [_vm._v("确定")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }